import React from 'react'

const CancelIcon = (
  <path
    d="M8.48485 7.5L14.524 0.30138C14.6252 0.181749 14.5401 0 14.3836 0H12.5477C12.4396 0 12.3361 0.0483128 12.2648 0.131135L7.28393 6.06902L2.3031 0.131135C2.23408 0.0483128 2.13055 0 2.02012 0H0.184233C0.0277918 0 -0.057331 0.181749 0.0438959 0.30138L6.08301 7.5L0.0438959 14.6986C0.0212202 14.7253 0.00667278 14.7579 0.00198037 14.7926C-0.00271204 14.8273 0.00264762 14.8626 0.0174236 14.8943C0.0321995 14.926 0.0557711 14.9529 0.0853393 14.9716C0.114908 14.9903 0.14923 15.0002 0.184233 15H2.02012C2.12825 15 2.23178 14.9517 2.3031 14.8689L7.28393 8.93098L12.2648 14.8689C12.3338 14.9517 12.4373 15 12.5477 15H14.3836C14.5401 15 14.6252 14.8182 14.524 14.6986L8.48485 7.5Z"
    fill="#FF3366"
  />
)

export default CancelIcon
